const validate = (values) => {
  const errors = {};

  if (!values.client && values.is_new) {
    errors.client = true;
  }

  if (!values.name) {
    errors.name = true;
  }

  if (!values.slug) {
    errors.slug = true;
  }

  if (values.password_required === true && !values.password) {
    errors.password = true;
  }

  if (!values.time_zone) {
    errors.time_zone = true;
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/validate.js